import { FC } from 'react';

import { TestStatus } from '@dbt-labs/dbt-dag';
import { Link, Tooltip } from '@dbt-labs/sourdough';

import { useLinkToExplorer } from '@/hooks/links';
import { useUrlProjectParams } from '@/hooks/params';
import { ParsedTestName } from '@/util/dbt/testName';
import { TestStatusIcon } from './TestStatusIcon';

export interface TestStatusRowProps {
  status: TestStatus | null;
  uniqueId: string;
  name: ParsedTestName;
  values?: string[];
}

export const TestStatusRow: FC<TestStatusRowProps> = ({
  status,
  uniqueId,
  name,
  values,
}) => {
  const projectScope = useUrlProjectParams();
  const testHref = useLinkToExplorer('resourceDetails')({
    ...projectScope,
    dbtUniqueId: uniqueId,
  });
  if (!status) {
    return null;
  }
  return (
    <li key={uniqueId} className="m-0.5 block h-6 text-xs">
      <Tooltip
        hidden={!values}
        content={
          <>
            <strong>Accepted values: </strong>
            {Array.isArray(values) ? values.join(', ') : values}
          </>
        }
        className="flex"
      >
        <TestStatusIcon status={status} className="mr-2 align-middle" />
        <Link isInternal to={testHref} className="align-middle">
          {name.name.toUpperCase()}
        </Link>
      </Tooltip>
    </li>
  );
};
interface TestStatusRowsProps {
  tests: TestStatusRowProps[];
  className?: string;
}

export const TestStatusRows: FC<TestStatusRowsProps> = ({ tests, className }) => {
  return tests.length ? (
    <ul
      data-testid="test-badges"
      aria-label="Tests"
      className={`overflow-hidden bg-bgBackground ${className} space-y-2 py-2`}
    >
      {tests.map((test) => (
        <TestStatusRow {...test} key={test.uniqueId} />
      ))}
    </ul>
  ) : null;
};
